import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.module.css";
import cx from "classnames";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import addToMailchimp from "gatsby-plugin-mailchimp";
import SvgTelegram from "./icons/telegram";
import { sendFormDataToWebjack } from "../../../intergrations/web-jack";

const Success = ({ logo }) => {
  return (
    <div className={cx(styles.successRoot)}>
      <div className={styles.courseLogo}>
        {logo && <img src={logo} alt={"Логотип курса"}></img>}
      </div>
      <div className={styles.textContainer}>
        <h1 className={styles.title}>Ура!</h1>
        <p className={styles.desc}>
          Заявка на курс принята. <br />
          Мы скоро с вами свяжемся.
        </p>
      </div>
    </div>
  );
};

const OrderForm = ({
  title,
  logo,
  priceUSDT,
  priceETH,
  promocodes,
  setPrice,
  setPriceETH,
  setPriceUSDT,
  price,
}) => {
  const [isFormSent, setFormState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentUtm, setUtm] = useState("Нет меток");
  const [promoRight, setPromoRight] = useState(false);
  const [priceBeforePromo, setPriceBeforePromo] = useState(null);
  const [promoRightText, setPromoRightText] = useState(null);
  const [promoBtnText, setPromoBtnText] = useState("Применить");

  const promoRef = useRef(null);

  const promocodesFromContentful = promocodes[0].node.promocodes;

  const promocodesToLowerCase = promocodesFromContentful.reduce((sum, item) => {
    sum[(item.name || "").toLowerCase()] = item.sum;
    return sum;
  }, {});

  const reusablePromocodes = Object.keys(promocodesToLowerCase);

  // обработчик кнопки Применить промокод
  const handlePromo = (e) => {
    e.preventDefault();

    var currentPromocodes = reusablePromocodes.map((v) => v.toLowerCase());

    var promocodeInput = promoRef.current;

    var promocode = promocodeInput.value.toLowerCase().replace(/\s/g, "");

    if (reusablePromocodes !== promocode) {
      setPromoBtnText("Не угадали :(");
    }

    const promocodeSuccess = () => {
      promocodeInput.style.cssText =
        "color: #006fc2; background-color: #fff; user-select: none; -moz-user-select: none; -khtml-user-select: none;-webkit-user-select: none; -o-user-select: none;";
      promocodeInput.setAttribute("disabled", "disabled");
      setPromoRightText(`${promocodeInput.value} ✔︎`);
      setPromoBtnText("Сработало!");
      setPromoRight(true);
    };

    // промокод со скидкой либо в процентах, либо в рублях
    if (currentPromocodes.indexOf(promocode) > -1) {
      const discountFromReusablePromocode = promocodesToLowerCase[promocode];

      if (discountFromReusablePromocode < 100) {
        setPriceBeforePromo(price);
        setPrice(price - price * (discountFromReusablePromocode / 100));
        setPriceETH(
          priceETH - priceETH * (discountFromReusablePromocode / 100)
        );
        setPriceUSDT(
          priceUSDT - priceUSDT * (discountFromReusablePromocode / 100)
        );
        promocodeSuccess();
      } else {
        setPriceBeforePromo(price);
        setPrice(price - discountFromReusablePromocode);
        setPriceETH(priceETH - discountFromReusablePromocode);
        setPriceUSDT(priceUSDT - discountFromReusablePromocode);
        promocodeSuccess();
      }
    }
  };

  // цена для отображения
  var priceToShow = ("" + price).split("");
  if (priceToShow.length === 5) {
    priceToShow.splice(2, 0, "&thinsp;");
    priceToShow = priceToShow
      .toString()
      .replace(/[, ]+/g, "")
      .trim();
  } else {
    priceToShow.splice(1, 0, "&thinsp;");
    priceToShow = priceToShow
      .toString()
      .replace(/[, ]+/g, "")
      .trim();
  }

  useEffect(() => {
    setUtm(localStorage.getItem("currentUtm"));
  }, []);

  const size = useWindowSize().width;
  const deviseForOrder = isDesktop();
  function isDesktop() {
    if (size > 1024) {
      return "С десктопа";
    } else {
      return "С мобильного";
    }
  }
  function useWindowSize() {
    const isClient = typeof window === "object";
    function getSize() {
      return {
        width: isClient ? window.innerWidth : undefined,
        height: isClient ? window.innerHeight : undefined,
      };
    }
    const [windowSize, setWindowSize] = useState(getSize);

    useEffect(() => {
      if (!isClient) {
        return false;
      }

      function handleResize() {
        setWindowSize(getSize());
      }
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowSize;
  }

  const nameOfCourse = title;
  const inputName = useRef(null);
  const inputPhone = useRef(null);
  const inputEmail = useRef(null);

  useEffect(() => {
    inputEmail.current.addEventListener("change", function() {
      localStorage.setItem("nameOfCourse", nameOfCourse);
      localStorage.setItem("nameOfStudent", inputName.current.value);
      localStorage.setItem("phone", inputPhone.current.value);
      localStorage.setItem("email", inputEmail.current.value);
    });
  }, [inputEmail]);

  return (
    <div className={styles.container}>
      {isFormSent && <Success logo={logo} />}

      <Formik
        initialValues={{
          name: "",
          phone: "",
          email: "",
          promo: "",
          company: "",
        }}
        validate={(values) => {
          const errors = {};
          Object.keys(values).forEach((name) => {
            if (
              name === "email" &&
              values[name] !== "" &&
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values[name])
            ) {
              return (errors[name] = "Неверный email");
            }
          });
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          setIsLoading(true);
          addToMailchimp(values.email);
          sendFormDataToWebjack({
            values,
            webhook: "8effa5927cf64e4bb9b70e6540caa81c",
            params: [
              "company",
              "promo",
              "email",
              "phone",
              "name",
              "utm_content",
              "utm_medium",
              "utm_source",
              "utm_campaign",
              "utm_source",
              "utm_medium",
              "ysclid",
            ],
          });

          {
            const payload = {
              title: `${title}`,
              price: `<b>Цена за курс:</b> ${price * 15}₽.`,
              promocode: `<b>Промокод:</b> ${values.promo}`,
              name: `<b>Имя:</b> ${values.name}`,
              tel: `<b>Тел:</b> ${values.phone}`,
              email: `<b>Email:</b> ${values.email}`,
              company: `<b>Тип оплаты: </b>${
                values.company ? "От компании." : "Студент платит сам."
              }`,
              utm: `<b>utm-метка</b> ${currentUtm}`,
              isDesktop: `<b>Откуда заявка</b>: ${deviseForOrder}`,
            };

            axios({
              url: "/api/newOrder.js",
              method: "POST",
              data: payload,
              headers: {
                "content-type": "application/json",
              },
            })
              .then(() => {
                setIsLoading(true);
                setSubmitting(false);
                setFormState(true);
              })
              .catch((err) => {
                setIsLoading(false);
                console.error(err);
                setSubmitting(false);
                alert("Ошибка при отправке формы. Повторите попытку позднее!");
              });
          }
          setSubmitting(false);
        }}
        render={({ values, errors, touched, handleChange, handleSubmit }) => (
          <Form
            name="OrderForm"
            autoComplete="off"
            onSubmit={handleSubmit}
            className={cx("order", {
              [styles.hidden]: isFormSent === true,
            })}
            style={{ opacity: isFormSent ? "0" : "1" }}
          >
            <div className={styles.row}>
              <div className={styles.field}>
                <Field
                  type="text"
                  name="name"
                  className={styles.input}
                  value={values.name}
                  innerRef={inputName}
                  onChange={handleChange}
                  required
                />
                <p className={styles.inputTitle}>Имя</p>
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.field}>
                <Field
                  type="text"
                  name="phone"
                  innerRef={inputPhone}
                  className={styles.input}
                  value={values.phone}
                  onChange={handleChange}
                  required
                />
                <p className={styles.inputTitle}>Телефон / телеграм</p>
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.field}>
                {errors.email && touched.email ? (
                  <div className={styles.errorMsg}>{errors.email}</div>
                ) : null}
                <Field
                  type="text"
                  name="email"
                  innerRef={inputEmail}
                  className={styles.input}
                  value={values.email}
                  onChange={handleChange}
                  required
                />
                <p className={styles.inputTitle}>Email</p>
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.promoContainer}>
                <Field
                  disabled={values.company ? 1 : 0}
                  id="promo"
                  type="text"
                  name="promo"
                  placeholder="Промокод"
                  className={styles.promoInput}
                  value={values.promo}
                  onChange={handleChange}
                  innerRef={promoRef}
                />
                <button
                  disabled={values.company ? 1 : 0 || promoRight ? 1 : 0}
                  className={[
                    styles.btnPromo,
                    values.promo === "" ? styles.disableBtn : null,
                  ].join(" ")}
                  onClick={handlePromo}
                  type="button"
                  id="promoBtn"
                >
                  {promoBtnText}
                </button>
              </div>
            </div>

            <div className={styles.row}>
              <label className={styles.containerCheckbox}>
                <div className={styles.checkboxWrapper}>
                  <Field
                    defaultChecked={false}
                    className={styles.checkbox}
                    type="checkbox"
                    name="company"
                    id="companyPayment"
                    value={values.companyPayment}
                    onChange={handleChange}
                  />
                  <span className={styles.customCheckbox}></span>
                </div>
                <p className={styles.checkboxText}>От компании</p>
              </label>
            </div>

            <button
              className={cx(styles.btnSubmit, "btnSubmitForSeo", {
                [styles.disabled]:
                  values.name !== "" &&
                  !errors.name &&
                  !errors.phone &&
                  !errors.email,
              })}
              type="submit"
              disabled={
                values.name === "" ||
                values.email === "" ||
                values.phone === "" ||
                errors.email
                  ? 1
                  : 0
              }
            >
              {isLoading ? "Отправляем…" : "Записаться на курс"}
            </button>
            <div className={styles.personalInfo}>
              Или свяжитесь с{" "}
              <a
                href="https://t.me/guidedao_xyz"
                target="_blank"
                className={styles.linkToPrivacy}
              >
                консультантом в телеграме
              </a>{" "}
              <a href="https://t.me/guidedao_xyz" target="_blank">
                <SvgTelegram />
              </a>
            </div>
          </Form>
        )}
      />
    </div>
  );
};

export default OrderForm;
